import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import {findSuppliersByQueryString} from "../../utils/requestUtils";
import {UserPermission} from "../../utils/utils";
import Loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";

const apiUrl = Config.apiUrl;
const SupplierList = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    let [suppliers, setSuppliers] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const response = await findSuppliersByQueryString(query);
            setSuppliers(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []); // Empty dependency array ensures that useEffect runs only once, similar to componentDidMount

    async function deleteSupplier(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/suppliers/' + id;
            await makeRequest(url, 'DELETE', {'Useruuid': Cookies.get('userUUID')});
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };

    if (loadingPermissions) {
        return <Loading></Loading>;
    }
    if (hasUserPermission(UserPermission.LIST_SUPPLIER) === false) {
        navigate('/unauthorizedaccess');
    }

    return (
        <>
            <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                <div className="header-label">Consulta de Fornecedores</div>
                {hasUserPermission(UserPermission.CREATE_SUPPLIER) &&
                    <button className={"new-button"} onClick={() => navigate('/app/supplier')}>Novo</button>
                }
            </div>

            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
            </div>

            <table style={{width: '580px'}}>

                <tr>
                    <th>
                        Código
                    </th>
                    <th>
                        Nome
                    </th>
                    <th/>
                    <th/>
                </tr>
                <tbody style={{overflowY: 'auto'}}>

                {suppliers.map((supplier, index) => (


                    <tr>
                        <td>
                            <div key={index}>{supplier.code}</div>
                        </td>
                        <td>
                            <div key={index}>{supplier.name}</div>
                        </td>
                        <td>
                            {hasUserPermission(UserPermission.EDIT_SUPPLIER) &&
                                <button className="edit-button" onClick={async () => {
                                    await navigate('/app/supplier?id=' + supplier.id);
                                }}>Editar
                                </button>
                            }
                        </td>
                        <td>
                            {hasUserPermission(UserPermission.REMOVE_SUPPLIER) &&
                                <button className="remove-button" onClick={async () => {
                                    // eslint-disable-next-line no-restricted-globals
                                    if (window.confirm('Deseja realmente excluir?')) {
                                        await deleteSupplier(supplier.id);
                                    }
                                }}>Excluir
                                </button>
                            }
                        </td>

                    </tr>
                ))}
                </tbody>
                {suppliers.length === 0 && (<tfoot>{loading ? 'Carregando...' : `Nenhum item encontrado.`}</tfoot>)}
            </table>


        </>
    );
};

export default SupplierList;
